import { Box, Typography, Paper, Container, Avatar, Divider, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AboutUs() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme =>
          theme.palette.mode === "dark"
            ? "linear-gradient(135deg, #20232a 40%, #202c39 100%)"
            : "linear-gradient(135deg, #f6f8fa 40%, #dbeafe 100%)",
        pt: 8,
        pb: 8,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={8}
          sx={{
            p: { xs: 2, sm: 6 },
            borderRadius: { xs: 4, sm: 8 },
            backdropFilter: "blur(7px)",
            background:
              theme.palette.mode === "dark"
                ? "rgba(36,38,43, 0.82)"
                : "rgba(255,255,255,0.86)",
            boxShadow:
              "0 10px 32px 0 rgba(80,180,130,0.16), 0 1.5px 8px 0 rgba(25,118,210,0.12)",
          }}
        >
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Box
              sx={{
                mx: "auto",
                mb: 2.5,
                width: 110,
                height: 110,
                borderRadius: "50%",
                boxShadow: "0 2px 16px 0 #49bc9080",
                background:
                  "linear-gradient(135deg, #49bc90 0%, #1976d2 60%, #f7d774 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 1.5,
              }}
            >
              <Avatar
                src="/company_logo.png"
                alt="App Logo"
                sx={{
                  width: 82,
                  height: 82,
                  bgcolor: "transparent",
                  boxShadow: "0 1.5px 8px #1976d255",
                  borderRadius: 4,
                }}
                variant="rounded"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                mt: 1,
                mb: 1.5,
                fontWeight: 800,
                letterSpacing: 1.5,
                background: `linear-gradient(90deg, #1976d2 35%, #49bc90 80%, #f7d774 100%)`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: { xs: 28, sm: 40 },
              }}
            >
              {t("about_us_title")}
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Stack spacing={3} sx={{ mb: 1 }}>
            <Typography variant="body1" sx={{ fontSize: "1.17rem", textAlign: "justify", fontWeight: 500 }}>
              {t("about_us_company_intro")}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: "1.12rem", color: "text.secondary", textAlign: "justify" }}>
              {t("about_us_what_is_incooking")}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: "1.12rem", color: "text.secondary", textAlign: "justify" }}>
              {t("about_us_vision")}
            </Typography>
          </Stack>

          <Divider sx={{ my: 4, opacity: 0.5 }} />

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 700,
                letterSpacing: 0.5,
                color: theme.palette.primary.main,
              }}
            >
              {t("about_us_features")}
            </Typography>
            <Box component="ul" sx={{ pl: 3.5, mb: 3, listStyle: "disc" }}>
              {[1,2,3,4].map(idx => (
                <li key={idx}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "1.08rem", color: "text.primary", fontWeight: 500 }}
                  >
                    {t(`about_us_features_${idx}`)}
                  </Typography>
                </li>
              ))}
            </Box>
          </Box>

          <Divider sx={{ my: 4, opacity: 0.5 }} />

          <Stack spacing={2} sx={{ alignItems: "center" }}>
            <Typography variant="body2" color="text.secondary">
              {t("about_us_contact")}{" "}
              <b>
                <a
                  href="mailto:info@brainstorm-visions.com"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "underline",
                    wordBreak: "break-all",
                  }}
                >
                  info@brainstorm-visions.com
                </a>
              </b>
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {t("about_us_address")}
              <br />
              1908 Thomes Ave STE 12392, Cheyenne, WY 82001, USA
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
